import { RiskEngine } from "../../../lib/core/trading/RiskEngine";
const previewRiskEngine = new RiskEngine();
/** Validate dùng chung Modal + Dock (Dock tự render text lỗi theo ngôn ngữ của nó). */
export function validateCandidate(candidate, rules, account, markPrice, currentPosition) {
    const ruleCheck = rules.validateOrder(candidate);
    if (!ruleCheck.valid) {
        return { ruleOk: false, ruleReason: ruleCheck.reason, riskOk: true };
    }
    const riskCheck = previewRiskEngine.validateOrderRisk(candidate, {
        accountId: "preview",
        balance: account.equity,
        equity: account.equity,
        marginUsed: Math.max(0, account.equity - account.freeMargin),
        freeMargin: account.freeMargin,
        buyingPower: account.buyingPower,
        currency: account.baseCurrency,
        pnl: 0,
        pnlPercent: 0,
    }, rules, markPrice, currentPosition ?? undefined);
    if (!riskCheck.valid) {
        return { ruleOk: true, riskOk: false, riskReason: riskCheck.reason, requiredMargin: riskCheck.requiredMargin };
    }
    return { ruleOk: true, riskOk: true, requiredMargin: riskCheck.requiredMargin };
}
export function parseNumber(text) {
    const stripped = text.replace(/[^0-9.]/g, "");
    if (stripped === "")
        return undefined;
    const value = Number(stripped);
    return !Number.isFinite(value) ? undefined : value;
}
export function buildCandidate(draft) {
    const candidate = {
        symbol: draft.symbol,
        side: draft.side,
        type: draft.type,
        quantity: draft.quantity,
        price: draft.type === "limit" || draft.type === "plo" ? draft.limitPrice : undefined,
        stopPrice: draft.type === "stop" || draft.type === "trailing_stop" ? draft.stopPrice : undefined,
        bracket: draft.takeProfitPrice != null || draft.stopLossPrice != null || draft.trailingStopDeltaTicks != null
            ? {
                takeProfitPrice: draft.takeProfitPrice,
                stopLossPrice: draft.stopLossPrice,
                trailingStopDeltaTicks: draft.trailingStopDeltaTicks,
            }
            : undefined,
        timeInForce: draft.timeInForce ?? "GTC",
    };
    return {
        candidate,
        entryPrice: draft.limitPrice ?? draft.stopPrice,
    };
}
/** Quy offset ticks về giá tuyệt đối theo hướng lệnh (mua: ask + n; bán: bid - n). */
export function offsetTicksToPrice(markPrice, side, offsetTicks, tickSize) {
    if (!Number.isFinite(markPrice) || !Number.isFinite(offsetTicks) || !(tickSize > 0))
        return markPrice;
    const raw = side === "buy" ? markPrice + offsetTicks * tickSize : markPrice - offsetTicks * tickSize;
    return Math.round(raw / tickSize) * tickSize;
}
/** Đổi % equity rủi ro ra khoảng giá SL: pct% * equity / (qty * multiplier). */
export function riskPercentToDistance(equityPercent, accountEquity, quantity, contractMultiplier) {
    if (!Number.isFinite(equityPercent) || equityPercent <= 0)
        return undefined;
    if (!(accountEquity > 0) || !(quantity > 0) || !(contractMultiplier > 0))
        return undefined;
    return ((equityPercent / 100) * accountEquity) / (quantity * contractMultiplier);
}
const TYPE_LABELS = {
    market: "MARKET",
    limit: "LIMIT",
    stop: "STOP",
    stop_limit: "STOP LIMIT",
    trailing_stop: "TRAIL",
    // P1.2c VN: mã lệnh sàn (không dịch, như TIF codes).
    ato: "ATO",
    atc: "ATC",
    mp: "MP",
    mtl: "MTL",
    plo: "PLO",
};
/** Dòng tóm tắt nút submit kiểu TV: "MUA 100 FPT @ 128.500 GIỚI HẠN". */
export function formatSubmitSummary(input) {
    const vi = input.locale !== "en";
    const sideLabel = input.side === "buy" ? (vi ? "MUA" : "BUY") : (vi ? "BÁN" : "SELL");
    const pricePart = input.price != null ? ` @ ${input.price.toLocaleString("en-US")}` : "";
    return `${sideLabel} ${input.quantity.toLocaleString("en-US")} ${input.symbol}${pricePart} ${TYPE_LABELS[input.type]}`;
}
/** Label loại lệnh dùng chung (review + nút submit). */
export function formatOrderTypeLabel(type, locale) {
    return TYPE_LABELS[type] ?? type.toUpperCase();
}
/**
 * Dựng view-model review từ candidate đã validate.
 * `contractMultiplier` mặc định 1 (market VN không nhân).
 */
export function buildOrderReview(input) {
    const { candidate } = input;
    const price = candidate.price ?? candidate.stopPrice ?? input.markPrice;
    const multiplier = input.contractMultiplier ?? 1;
    const notional = candidate.quantity * price * multiplier;
    return {
        side: candidate.side,
        symbol: candidate.symbol,
        type: candidate.type,
        quantity: candidate.quantity,
        price,
        notional,
        takeProfitPrice: candidate.bracket?.takeProfitPrice,
        stopLossPrice: candidate.bracket?.stopLossPrice,
        requiredMargin: input.requiredMargin,
        buyingPower: input.buyingPower,
    };
}
